import SavedItemsSubview from './subviews/saved-items';
import TestDrivesSubview from './subviews/test-drives';
import GarageSubview from './subviews/garage';
import PreferredDealerSubview from './subviews/preferred-dealer';
import OrderStatusSubview from './subviews/order-status';
import SavedItemsModalSubview from './subviews/saved-items-modal';
import Masonry from '../../../../node_modules/macy';

export default class DashboardView {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el.querySelector('.dashboard-view');
        this.container = this.el.querySelector('.dashboard-container');
        this.dealerUrl = this.container.dataset.dealerUrl;
        this.savedItemsModalSubview = new SavedItemsModalSubview(this);
        this.subviews = {
            'order-status': new OrderStatusSubview(this),
            'saved-items': new SavedItemsSubview(this),
            'test-drives': new TestDrivesSubview(this),
            'garage': new GarageSubview(this),
            'preferred-dealer': new PreferredDealerSubview(this),
        };

        this.dashboardCards = Masonry({
            container: '.dashboard-container',
            margin: 24,
            columns: 2,
            breakAt: {
                680: 1,
            },
        });

        this.bind();
    }

    update() {
        this.dashboardCards?.recalculate(true);
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.populate());
    }

    populate() {
        Object.values(this.subviews).forEach((v) => v.populate?.());
    }

    refreshOrder() {
        this.parent.refreshOrder();
    }

    show() {
        this.el.classList.remove('hide');
        this.dashboardCards?.recalculate(true);
    }

    hide() {
        this.el.classList.add('hide');
    }
}
